(function () {
  function refreshDrawer() {
    document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { open: true } }));
  }
  function json(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); });
  }
  function flag(k, v) {
    try { if (v === undefined) return sessionStorage.getItem(k); if (v === null) sessionStorage.removeItem(k); else sessionStorage.setItem(k, v); } catch (e) { return null; }
  }

  var PROT_LOCK = false;
  class MtmCartProtection extends HTMLElement {
    connectedCallback() {
      var input = this.querySelector('input[type=checkbox]');
      if (!input || this._bound) return;
      this._bound = true;
      var vid = this.dataset.variantId;
      var real = Number(this.dataset.realCount || 0);

      input.addEventListener('change', function () {
        input.disabled = true;
        flag('mtmProtOff', input.checked ? '0' : '1');
        var p = input.checked
          ? json('/cart/add.js', { items: [{ id: Number(vid), quantity: 1 }] })
          : json('/cart/change.js', { id: String(vid), quantity: 0 });
        p.then(refreshDrawer).catch(function () { input.disabled = false; });
      });

      /* Only protection left in the cart: remove it so the cart can become empty. */
      if (real === 0 && input.checked) {
        json('/cart/change.js', { id: String(vid), quantity: 0 }).then(refreshDrawer).catch(function () {});
        return;
      }

      /* Default ON: add automatically unless the customer unticked it before in this session.
         Waits for the VIP+ step to finish first (two parallel cart writes made the protection get lost),
         one global lock so several drawer copies never add it twice, then checks the cart and retries until it is in. */
      if (!input.checked && real > 0 && flag('mtmProtOff') !== '1') {
        var tries = 0;
        var attempt = function () {
          if (PROT_LOCK) return;
          if (VIP.busy && tries < 20) { tries++; setTimeout(attempt, 300); return; }
          PROT_LOCK = true;
          fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) {
            var line = c.items.filter(function (i) { return String(i.variant_id) === String(vid); })[0];
            var hasReal = c.items.some(function (i) { return String(i.variant_id) !== String(vid) && i.handle !== 'cozy-cuddles-vip'; });
            if (line) {
              if (line.quantity > 1) { return json('/cart/change.js', { id: line.key, quantity: 1 }).then(refreshDrawer); }
              return;
            }
            if (!hasReal || flag('mtmProtOff') === '1') return;
            if (Number(flag('mtmProtTried') || 0) >= 3) return;
            flag('mtmProtTried', String(Number(flag('mtmProtTried') || 0) + 1));
            input.disabled = true;
            return json('/cart/add.js', { items: [{ id: Number(vid), quantity: 1 }] })
              .then(function (res) { if (res.ok) { flag('mtmProtTried', null); refreshDrawer(); } else { input.disabled = false; } });
          }).catch(function () { input.disabled = false; }).then(function () { PROT_LOCK = false; });
        };
        setTimeout(attempt, 600);
      }
    }
  }
  if (!customElements.get('mtm-cart-protection')) customElements.define('mtm-cart-protection', MtmCartProtection);

  /* ---- VIP+ membership: default ON (Tom, 27-10-2026). Only a customer who actively chooses Guest is opted out (remembered in the browser). ---- */
  var VIP = { busy: false, expanded: false };
  function vipOptedOut() { try { return localStorage.getItem('mtmVipOptOut') === '1'; } catch (e) { return false; } }
  function vipSetOpt(off) { try { if (off) localStorage.setItem('mtmVipOptOut', '1'); else localStorage.removeItem('mtmVipOptOut'); } catch (e) {} }
  window.mtmVipJoinIntent = function () { vipSetOpt(false); };

  class MtmCartVip extends HTMLElement {
    connectedCallback() {
      if (this._bound) return;
      this._bound = true;
      var self = this;
      this.setAttribute('data-expanded', VIP.expanded ? 'true' : 'false');
      this.addEventListener('click', function (e) {
        var head = e.target.closest('.mv__head');
        if (head) {
          var ex = self.getAttribute('data-expanded') === 'true';
          self.setAttribute('data-expanded', ex ? 'false' : 'true');
          VIP.expanded = !ex;
          return;
        }
        if (e.target.closest('.mv__btn')) self.choose(self.dataset.joined !== 'true');
      });
      this.addEventListener('change', function (e) {
        if (e.target.classList.contains('mv__radio-vip')) self.choose(true);
        else if (e.target.classList.contains('mv__radio-guest')) self.choose(false);
      });
      this.ensure();
    }
    choose(join) {
      if (VIP.busy) return;
      vipSetOpt(!join);
      /* Choosing Guest ends a membership-only cart (started from the membership page). */
      if (!join) flag('mtmVipSolo', null);
      flag('mtmVipTried', null);
      this.run(join ? (this.dataset.joined === 'true' ? 'apply' : 'add') : (this.dataset.joined === 'true' ? 'remove' : 'clear'));
    }
    ensure() {
      var d = this.dataset;
      var real = Number(d.real || 0), joined = d.joined === 'true', on = d.codeOn === 'true', off = vipOptedOut();
      /* Membership-only cart: started with 'Start trial' on the membership page. Keep it until real products are added. */
      var solo = flag('mtmVipSolo') === '1';
      if (real > 0 && solo) { flag('mtmVipSolo', null); solo = false; }
      var act = null;
      if (real === 0) { if (joined && !solo) act = 'remove'; else if (!joined && on) act = 'clear'; }
      else if (off) { if (joined) act = 'remove'; else if (on) act = 'clear'; }
      else if (!joined) { act = on ? 'clear' : 'add'; if (on) act = 'add'; }
      else if (!on) act = 'apply';
      if (!act || VIP.busy) return;
      var key = [real, joined, on, off, act].join('-');
      if (flag('mtmVipTried') === key) return;
      flag('mtmVipTried', key);
      this.run(act);
    }
    run(act) {
      var d = this.dataset, code = d.code;
      VIP.busy = true;
      function apply() { return fetch('/discount/' + encodeURIComponent(code), { headers: { Accept: 'text/html' } }).catch(function () {}); }
      function clear() { return json('/cart/update.js', { discount: '' }).catch(function () {}); }
      var p;
      if (act === 'add') {
        p = json('/cart/add.js', { items: [{ id: Number(d.variantId), quantity: 1, selling_plan: Number(d.planId) }] }).then(apply);
      } else if (act === 'apply') {
        p = apply();
      } else if (act === 'remove') {
        p = fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) {
          var line = c.items.filter(function (i) { return String(i.variant_id) === String(d.variantId); })[0];
          return line ? json('/cart/change.js', { id: line.key, quantity: 0 }) : null;
        }).then(clear);
      } else {
        p = clear();
      }
      p.then(function () { VIP.busy = false; refreshDrawer(); }).catch(function () { VIP.busy = false; });
    }
  }
  if (!customElements.get('mtm-cart-vip')) customElements.define('mtm-cart-vip', MtmCartVip);

  /* The recommendations endpoint returns prices in cents without a decimal point ("2995"); products.json returns "29.95". */
  function money(v) {
    var n = Number(v);
    if (String(v).indexOf('.') === -1) n = n / 100;
    try {
      return new Intl.NumberFormat(document.documentElement.lang || undefined, { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'GBP' }).format(n);
    } catch (e) { return n.toFixed(2); }
  }
  function esc(s) { var d = document.createElement('div'); d.textContent = s; return d.innerHTML; }

  class MtmCartUpsell extends HTMLElement {
    connectedCallback() {
      if (this._loaded) return;
      this._loaded = true;
      var pid = this.dataset.productId;
      if (!pid) return;
      var inCart = (this.dataset.inCart || '').split(',').filter(Boolean);
      var self = this;
      fetch('/recommendations/products.json?product_id=' + pid + '&limit=8&intent=related')
        .then(function (r) { return r.json(); })
        .then(function (d) {
          var items = (d.products || []).filter(function (p) {
            return p.available && p.handle !== 'shipping-protection' && p.handle !== 'cozy-cuddles-vip' && inCart.indexOf(String(p.id)) === -1;
          }).slice(0, 6);
          if (!items.length) return;
          var html = '<p class="mtm-up__title">' + esc(self.dataset.heading || 'You may also like') + '</p><div class="mtm-up__row">';
          items.forEach(function (p) {
            var vs = p.variants.filter(function (v) { return v.available; });
            if (!vs.length) return;
            var v = vs[0];
            var img = p.featured_image || (p.images && p.images[0]) || '';
            var price = (v.compare_at_price && Number(v.compare_at_price) > Number(v.price) ? '<s>' + money(v.compare_at_price) + '</s> ' : '') + money(v.price);
            html += '<div class="mtm-up__card"><a class="mtm-up__img" href="' + p.url + '" tabindex="-1" aria-hidden="true">' + (img ? '<img src="' + img + '" alt="" loading="lazy" width="120" height="120">' : '') + '</a>' +
              '<a class="mtm-up__name" href="' + p.url + '">' + esc(p.title) + '</a><span class="mtm-up__price">' + price + '</span>';
            if (vs.length > 1) {
              html += '<select class="mtm-up__select" aria-label="Option for ' + esc(p.title) + '">' + vs.map(function (x) { return '<option value="' + x.id + '">' + esc(x.title) + '</option>'; }).join('') + '</select>';
            }
            html += '<button type="button" class="mtm-up__add" data-variant-id="' + v.id + '">Add</button></div>';
          });
          html += '</div><p class="mtm-up__error" role="alert" hidden></p>';
          self.innerHTML = html;
          self.hidden = false;
          self.addEventListener('click', function (e) {
            var btn = e.target.closest('.mtm-up__add');
            if (!btn) return;
            var card = btn.closest('.mtm-up__card');
            var sel = card.querySelector('.mtm-up__select');
            var id = sel ? sel.value : btn.dataset.variantId;
            btn.disabled = true;
            json('/cart/add.js', { items: [{ id: Number(id), quantity: 1 }] }).then(function (res) {
              if (res.ok) { refreshDrawer(); }
              else {
                var err = self.querySelector('.mtm-up__error');
                err.textContent = res.data.description || 'Could not add this item.'; err.hidden = false; btn.disabled = false;
              }
            }).catch(function () { btn.disabled = false; });
          });
        })
        .catch(function () {});
    }
  }
  if (!customElements.get('mtm-cart-upsell')) customElements.define('mtm-cart-upsell', MtmCartUpsell);

  /* ---- Cart count: only real products count, not the VIP+ membership or the shipping protection (Tom, 23-10-2026) ----
     Only reacts to changes inside a <cart-count> element or to new nodes that contain one, so the page timers and other widgets never trigger it. */
  var countTimer = null;
  function fixCount() {
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) {
      var n = c.items.reduce(function (s, i) {
        return (i.handle === 'shipping-protection' || i.handle === 'cozy-cuddles-vip') ? s : s + i.quantity;
      }, 0);
      document.querySelectorAll('cart-count').forEach(function (el) {
        if (n < 100 && el.textContent.trim() !== String(n)) el.textContent = String(n);
        el.hidden = n === 0;
      });
    }).catch(function () {});
  }
  function scheduleCount() { clearTimeout(countTimer); countTimer = setTimeout(fixCount, 150); }
  function touchesCount(m) {
    var t = m.target && (m.target.nodeType === 1 ? m.target : m.target.parentElement);
    if (t && t.closest && t.closest('cart-count')) return true;
    for (var i = 0; i < m.addedNodes.length; i++) {
      var a = m.addedNodes[i];
      if (a.nodeType === 1 && (a.matches('cart-count') || a.querySelector('cart-count'))) return true;
    }
    return false;
  }
  document.addEventListener('DOMContentLoaded', function () {
    scheduleCount();
    new MutationObserver(function (list) { if (list.some(touchesCount)) scheduleCount(); }).observe(document.body, { childList: true, subtree: true, characterData: true });
  });
  document.addEventListener('cart:refresh', function () { setTimeout(scheduleCount, 600); });
})();